import { render, staticRenderFns } from "./figure-widget.vue?vue&type=template&id=bb616bea&scoped=true"
import script from "./figure-widget.vue?vue&type=script&lang=js"
export * from "./figure-widget.vue?vue&type=script&lang=js"
import style0 from "./figure-widget.vue?vue&type=style&index=0&id=bb616bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb616bea",
  null
  
)

export default component.exports